import React, { FunctionComponent, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import styles from "./Integration.module.css";
import { themeColors } from "../../Components/theme";
import { autoCreateApi, fetchAndSetOrgCountry, fetchApi } from "../../Services/organizations";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { showSnackbarAction } from "../../Redux/actions";
import { useLocation } from 'react-router-dom';
import Loading from "../../Components/Loading/Loading";
// Import theme variables
import "../../theme-vars.css";
import { useMediaQuery, useTheme } from "@mui/material";



type props = {
  user: any;
  contacts: any;
  history: any;
  role: any;
  organizationUsers: any;
  teamLeadUsers: any;
  theme: any;
  facebookUesrPageList: any;
  organizationId: any
};
interface LocationState {
  data: any;
}
const Acres: FunctionComponent<props> = ({
  user,
  contacts,
  history,
  role,
  organizationUsers,
  teamLeadUsers,
  theme,
  facebookUesrPageList,
  organizationId
}) => {
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm")); // Use theme breakpoints for mobile
  const dispatcher = useDispatch();
  const location = useLocation();
  const state = location.state as LocationState || {};
  const [API, setAPI] = useState<any[] | undefined>(undefined);
  const [load, setLoad] = useState(false);
  const [APIKey, setAPIKey] = useState("");
  const [countryCode,setcountryCode]=useState("+91");

  useEffect(() => {
     fetchAndSetOrgCountry(user.organization_id,(val) => setcountryCode(val));
   }, []);

  useEffect(() => {
    if (user.organization_id) {
      fetchApi(user.organization_id, (val) => setAPI(val));
    }
  }, [user.organization_id]);

  useEffect(() => {
    if (API !== undefined && API.length > 0) {
      const filteredData = API && API.filter(item => item.source === "99Acres");
      if (filteredData && filteredData.length > 0) {
        setAPIKey(filteredData[0].api_key)
      }
      const filterValue = API.some(item => item.source === "99Acres");
      const leadSourceFilter = state.data.some(
        (item: any) => item.leadSource?.toLowerCase() === "99acres".toLowerCase()
      );
      const leadSourceFilterData = state?.data?.filter(
        (item: any) => item.leadSource?.toLowerCase() === "99acres".toLowerCase()
      );
      if (!leadSourceFilter) {
        dispatcher(showSnackbarAction("Before configuring the lead source in '99Acres,' ensure it is added to the resources!!", "error"));
        return;
      }
      if (!filterValue) {
        autoCreateApi(
          organizationId,
          "99Acres",
          leadSourceFilterData[0]?.leadSource_id,
          countryCode,
        );
      }
    }
  }, [API]);

  const bodyData = {
    'customer_name': "",
    'contact_no': "",
    'email': "",
    'country_code': "",
    'project': "",
    'campaign': "99Acres",
    'token': APIKey
  }
  const containerStyles = {
    backgroundColor: theme
      ? themeColors.backgroundColor
      : themeColors.backgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
    fontFamily: "var(--font-family-main)",
    fontSize: "var(--font-size-small)"
  };
  const [copied, setCopied] = useState(false);
  const jsonBodyData = JSON.stringify(bodyData, null, 2);

  const handleCopyJson = () => {
    navigator.clipboard.writeText(jsonBodyData);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <>
      <div
        className={styles.parent}
        style={{ ...containerStyles, marginTop: isMobile ? "5%" : "4%", overflow: "hidden", maxHeight: "500px", overflowY: "scroll", marginBottom: "20px" }}
      >
        {load && <Loading />}
        <div
          className={styles.mobileContent} 
          style={{
            width: "80%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            margin: "20px 20px 80px 50px",
            boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
            fontFamily: "var(--font-family-main)"
          }}
        >
          <div style={{ fontSize: "var(--font-size-large)", fontWeight: "500", margin: "20px 0px 20px 0px", fontFamily: "var(--font-family-main)" }}>
            99Acres Integration
          </div>
          <div style={{ width: "80%", display: "flex", alignItems: "flex-start", justifyContent: "flex-start", flexDirection: "column", marginBottom: "50px", fontFamily: "var(--font-family-main)" }}>
            <p style={{ margin: 0, padding: 0, fontWeight: 600, fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)" }}>Receive New Leads from 99acres in Your Leads Rubix Account</p>
            <p style={{ fontSize: "var(--font-size-small)", marginTop: "5px", padding: 0, fontFamily: "var(--font-family-main)" }}>To integrate your 99acres leads with Leads Rubix, please forward the instructions below to your 99acres Account Manager:</p>
            <div style={{ backgroundColor: theme ? "lightgray" : "rgb(39, 41, 68)", width: "100%", fontFamily: "var(--font-family-main)" }}>
              <div style={{ margin: "10px 10px 10px 10px", textAlign: "center", position: "relative", fontFamily: "var(--font-family-main)" }}>
                <p style={{ margin: 0.3, padding: 0.3, fontWeight: 600, fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" }}>Integration Request:</p>
                <p style={{ margin: 0.3, padding: 0.3, fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-small)" }}>Please configure my 99acres account to send all leads directly to Leads Rubix CRM.</p>
                <p style={{ margin: 0.3, padding: 0.3, fontWeight: 600, fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" }}>Webhook Details:</p>
                <p style={{ margin: 0.3, padding: 0.3, fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" }}>Webhook URL:</p>
                <p style={{ margin: 0.3, padding: 0.3, fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-small)" }}>https://us-central1-leads-rubix.cloudfunctions.net/api-createContacts</p>
                <p style={{ margin: "0px", fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" }}>Method: POST</p>
                <p style={{ margin: "0px", fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-small)" }}>Payload Parameters:</p>
                <div style={{ position: "relative", textAlign: "left", marginTop: 8, fontFamily: "var(--font-family-main)" }}>
                  <ContentCopyIcon
                    onClick={handleCopyJson}
                    style={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                      cursor: "pointer",
                      color: copied ? "#272944" : "#555",
                      zIndex: 1,
                      fontSize: 16
                    }}
                    titleAccess={copied ? "Copied!" : "Copy JSON"}
                  />
                  <pre
                    style={{
                      background: "rgb(255, 250, 250)",
                      color: "#272944",
                      borderRadius: 4,
                      padding: "16px 40px 16px 16px",
                      fontSize: "var(--font-size-small)",
                      overflowX: "auto",
                      margin: 0,
                      fontFamily: "var(--font-family-main)"
                    }}
                  >
                    {jsonBodyData}
                  </pre>
                  {copied && (
                    <span style={{
                      position: "absolute",
                      top: 10,
                      right: 40,
                      color: "#272944",
                      fontSize: "var(--font-size-small)",
                      background: "#fff",
                      borderRadius: 4,
                      padding: "2px 8px",
                      fontFamily: "var(--font-family-main)"
                    }}>Copied!</span>
                  )}
                </div>
              </div>
            </div>
            <p style={{ marginTop: "5px", fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-small)" }}>
              Once the setup is completed, the 99acres team will activate the integration (typically within one week). After activation, your new leads will automatically flow into your Leads Rubix account.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    role: state.user.role,
    contacts: state.contacts,
    organizationUsers: state.organizationUsers.data,
    teamLeadUsers: state.teamLeadUsers.data,
    theme: state.theme.isLightMode,
    facebookUesrPageList: state.faceBookUserPagesData.data,
    organizationId: state.organization.id,
  };
};
export default connect(mapStateToProps)(Acres);
